import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import { DELETE_COUPON } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { COUPON_LIST_ADMIN_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import deleteCouponOnSuccess from 'root/src/client/logic/coupon/actions/deleteCouponOnSuccess'
import setLoadingBlockList from 'root/src/client/logic/list/actions/setLoadingBlockList'

// eslint-disable-next-line no-unused-vars, consistent-return
export default id => async (dispatch, getState) => {
	if (id) {
		dispatch(setLoadingBlockList(true, COUPON_LIST_ADMIN_MODULE_ID))
		await dispatch(apiRequest(DELETE_COUPON, { id }))
		dispatch(displayModal(undefined))
		dispatch(setLoadingBlockList(false, COUPON_LIST_ADMIN_MODULE_ID))
		return dispatch(deleteCouponOnSuccess({ id }))
	}
}
